//Reference: EN004

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';


export class StructureOrganizative extends Mappeable {
    ID: number;
    organizationalStructure: any;
    country: any;
    txtName: string;
    typeOrganizationalStructure: any;
    currency: any;
    mrkActive: boolean;
    DATE_INSERT: string;
    DATE_UPDATE: string;
    USER_INSERT: string;
    USER_UPDATE: string;

    constructor(o) {
        super(o);
        this.typeOrganizationalStructure = this.typeOrganizationalStructure ??  null 
        this.organizationalStructure = _.isUndefined(this.organizationalStructure) || _.isNull(this.organizationalStructure) || this.organizationalStructure === '' ? null : this.organizationalStructure;
        this.currency = this.currency ??  {} 
        this.country = this.country ??  {} 
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            country: this.country,
            currency: this.currency,
            mrkActive: this.mrkActive,
            organizationalStructure: this.organizationalStructure,
            typeOrganizationalStructure: this.typeOrganizationalStructure,
            txtName: this.txtName,
            txtDescription: "Default",
        }
    }
}